var _excluded = ["data"];
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import axios from 'axios';
import { parseAxiosCancelToken } from '../utils/axios';
export var AbstractEntityService = /*#__PURE__*/function () {
  function AbstractEntityService() {
    _classCallCheck(this, AbstractEntityService);
  }
  return _createClass(AbstractEntityService, [{
    key: "execFetchMany",
    value: function () {
      var _execFetchMany = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(url) {
        var opts,
          res,
          builtUrl,
          req,
          _req$data,
          data,
          meta,
          _args = arguments;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              opts = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
              res = AbstractEntityService.buildResponse();
              _context.prev = 2;
              builtUrl = AbstractEntityService.buildUrl(url, opts);
              _context.t0 = axios;
              _context.t1 = builtUrl;
              _context.t2 = _objectSpread;
              _context.t3 = {};
              _context.next = 10;
              return AbstractEntityService.buildRequestConfig(opts);
            case 10:
              _context.t4 = _context.sent;
              _context.t5 = (0, _context.t2)(_context.t3, _context.t4);
              _context.next = 14;
              return _context.t0.get.call(_context.t0, _context.t1, _context.t5);
            case 14:
              req = _context.sent;
              _req$data = req.data, data = _req$data.data, meta = _objectWithoutProperties(_req$data, _excluded);
              res.ok = true;
              res.data = data;
              res.meta = meta;
              _context.next = 24;
              break;
            case 21:
              _context.prev = 21;
              _context.t6 = _context["catch"](2);
              if (_context.t6 instanceof Error) {
                if (axios.isCancel(_context.t6)) {
                  res.cancelled = true;
                }
                res.error = _context.t6;
              } else {
                console.error(_context.t6);
              }
            case 24:
              return _context.abrupt("return", res);
            case 25:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[2, 21]]);
      }));
      function execFetchMany(_x) {
        return _execFetchMany.apply(this, arguments);
      }
      return execFetchMany;
    }()
  }, {
    key: "execFetchOne",
    value: function () {
      var _execFetchOne = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(url) {
        var opts,
          _args2 = arguments;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              opts = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {};
              return _context2.abrupt("return", this.execGet(url, opts));
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function execFetchOne(_x2) {
        return _execFetchOne.apply(this, arguments);
      }
      return execFetchOne;
    }()
  }, {
    key: "execGet",
    value: function () {
      var _execGet = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(url) {
        var opts,
          res,
          builtUrl,
          req,
          _args3 = arguments;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              opts = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : {};
              res = AbstractEntityService.buildResponse();
              _context3.prev = 2;
              builtUrl = AbstractEntityService.buildUrl(url, opts);
              _context3.t0 = axios;
              _context3.t1 = builtUrl;
              _context3.t2 = _objectSpread;
              _context3.t3 = {};
              _context3.next = 10;
              return AbstractEntityService.buildRequestConfig(opts);
            case 10:
              _context3.t4 = _context3.sent;
              _context3.t5 = (0, _context3.t2)(_context3.t3, _context3.t4);
              _context3.next = 14;
              return _context3.t0.get.call(_context3.t0, _context3.t1, _context3.t5);
            case 14:
              req = _context3.sent;
              res.ok = true;
              res.data = req.data.data;
              _context3.next = 22;
              break;
            case 19:
              _context3.prev = 19;
              _context3.t6 = _context3["catch"](2);
              if (_context3.t6 instanceof Error) {
                if (axios.isCancel(_context3.t6)) {
                  res.cancelled = true;
                }
                res.error = _context3.t6;
              } else {
                console.error(_context3.t6);
              }
            case 22:
              return _context3.abrupt("return", res);
            case 23:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[2, 19]]);
      }));
      function execGet(_x3) {
        return _execGet.apply(this, arguments);
      }
      return execGet;
    }()
  }, {
    key: "execPost",
    value: function () {
      var _execPost = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4(url, postData) {
        var opts,
          res,
          builtUrl,
          req,
          _args4 = arguments;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              opts = _args4.length > 2 && _args4[2] !== undefined ? _args4[2] : {};
              res = AbstractEntityService.buildResponse();
              _context4.prev = 2;
              builtUrl = AbstractEntityService.buildUrl(url, opts);
              _context4.t0 = axios;
              _context4.t1 = builtUrl;
              _context4.t2 = postData;
              _context4.t3 = _objectSpread;
              _context4.t4 = {};
              _context4.next = 11;
              return AbstractEntityService.buildRequestConfig(opts);
            case 11:
              _context4.t5 = _context4.sent;
              _context4.t6 = (0, _context4.t3)(_context4.t4, _context4.t5);
              _context4.next = 15;
              return _context4.t0.post.call(_context4.t0, _context4.t1, _context4.t2, _context4.t6);
            case 15:
              req = _context4.sent;
              res.ok = true;
              res.data = req.data.data;
              _context4.next = 23;
              break;
            case 20:
              _context4.prev = 20;
              _context4.t7 = _context4["catch"](2);
              if (_context4.t7 instanceof Error) {
                if (axios.isCancel(_context4.t7)) {
                  res.cancelled = true;
                }
                res.error = _context4.t7;
              } else {
                console.error(_context4.t7);
              }
            case 23:
              return _context4.abrupt("return", res);
            case 24:
            case "end":
              return _context4.stop();
          }
        }, _callee4, null, [[2, 20]]);
      }));
      function execPost(_x4, _x5) {
        return _execPost.apply(this, arguments);
      }
      return execPost;
    }()
  }, {
    key: "execCreate",
    value: function () {
      var _execCreate = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5(url, createDto) {
        var opts,
          _args5 = arguments;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              opts = _args5.length > 2 && _args5[2] !== undefined ? _args5[2] : {};
              return _context5.abrupt("return", this.execPost(url, createDto, opts));
            case 2:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function execCreate(_x6, _x7) {
        return _execCreate.apply(this, arguments);
      }
      return execCreate;
    }()
  }, {
    key: "execPatch",
    value: function () {
      var _execPatch = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6(url, updateDto) {
        var opts,
          res,
          builtUrl,
          req,
          _args6 = arguments;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              opts = _args6.length > 2 && _args6[2] !== undefined ? _args6[2] : {};
              res = AbstractEntityService.buildResponse();
              _context6.prev = 2;
              builtUrl = AbstractEntityService.buildUrl(url, opts);
              _context6.t0 = axios;
              _context6.t1 = builtUrl;
              _context6.t2 = updateDto;
              _context6.t3 = _objectSpread;
              _context6.t4 = {};
              _context6.next = 11;
              return AbstractEntityService.buildRequestConfig(opts);
            case 11:
              _context6.t5 = _context6.sent;
              _context6.t6 = (0, _context6.t3)(_context6.t4, _context6.t5);
              _context6.next = 15;
              return _context6.t0.patch.call(_context6.t0, _context6.t1, _context6.t2, _context6.t6);
            case 15:
              req = _context6.sent;
              res.ok = true;
              res.data = req.data.data;
              _context6.next = 23;
              break;
            case 20:
              _context6.prev = 20;
              _context6.t7 = _context6["catch"](2);
              if (_context6.t7 instanceof Error) {
                if (axios.isCancel(_context6.t7)) {
                  res.cancelled = true;
                }
                res.error = _context6.t7;
              } else {
                console.error(_context6.t7);
              }
            case 23:
              return _context6.abrupt("return", res);
            case 24:
            case "end":
              return _context6.stop();
          }
        }, _callee6, null, [[2, 20]]);
      }));
      function execPatch(_x8, _x9) {
        return _execPatch.apply(this, arguments);
      }
      return execPatch;
    }()
  }, {
    key: "execDelete",
    value: function () {
      var _execDelete = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7(url) {
        var opts,
          res,
          builtUrl,
          _args7 = arguments;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              opts = _args7.length > 1 && _args7[1] !== undefined ? _args7[1] : {};
              res = AbstractEntityService.buildResponse();
              _context7.prev = 2;
              builtUrl = AbstractEntityService.buildUrl(url, opts);
              _context7.t0 = axios;
              _context7.t1 = builtUrl;
              _context7.t2 = _objectSpread;
              _context7.t3 = {};
              _context7.next = 10;
              return AbstractEntityService.buildRequestConfig(opts);
            case 10:
              _context7.t4 = _context7.sent;
              _context7.t5 = (0, _context7.t2)(_context7.t3, _context7.t4);
              _context7.next = 14;
              return _context7.t0["delete"].call(_context7.t0, _context7.t1, _context7.t5);
            case 14:
              res.ok = true;
              res.data = 'success';
              _context7.next = 21;
              break;
            case 18:
              _context7.prev = 18;
              _context7.t6 = _context7["catch"](2);
              if (_context7.t6 instanceof Error) {
                if (axios.isCancel(_context7.t6)) {
                  res.cancelled = true;
                }
                res.error = _context7.t6;
              } else {
                console.error(_context7.t6);
              }
            case 21:
              return _context7.abrupt("return", res);
            case 22:
            case "end":
              return _context7.stop();
          }
        }, _callee7, null, [[2, 18]]);
      }));
      function execDelete(_x10) {
        return _execDelete.apply(this, arguments);
      }
      return execDelete;
    }()
  }], [{
    key: "buildUrl",
    value:
    /**
     * Adds additional query params found in opts to the provided url.
     */
    function buildUrl(url) {
      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var u = new URL(url);
      if (opts.query) {
        for (var key in opts.query) {
          if (opts.query.hasOwnProperty(key)) {
            var value = opts.query[key];
            if (value !== undefined) {
              u.searchParams.append(key, opts.query[key]);
            }
          }
        }
      }
      return u.toString();
    }

    /**
     * Builds standard axios request config shared between all api calls
     */
  }, {
    key: "buildRequestConfig",
    value: (function () {
      var _buildRequestConfig = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        var opts,
          _args8 = arguments;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              opts = _args8.length > 0 && _args8[0] !== undefined ? _args8[0] : {};
              _context8.next = 3;
              return parseAxiosCancelToken(opts);
            case 3:
              _context8.t0 = _context8.sent;
              return _context8.abrupt("return", {
                cancelToken: _context8.t0
              });
            case 5:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }));
      function buildRequestConfig() {
        return _buildRequestConfig.apply(this, arguments);
      }
      return buildRequestConfig;
    }()
    /**
     * Builds standard response package shared between all api responses
     */
    )
  }, {
    key: "buildResponse",
    value: function buildResponse() {
      return {
        ok: false,
        data: undefined,
        meta: {},
        cancelled: false,
        error: undefined
      };
    }
  }]);
}();